module.exports = __webpack_public_path__ + "static/dateFilter-fe2ca7428acc973bb5509cded3025ad1.gif";